/**
 * 外部依存なしの ULID 生成器
 * 仕様: Crockford Base32 / 48bit タイムスタンプ + 80bit ランダム
 * https://github.com/ulid/spec
 */

// Crockford Base32 文字セット（大文字、紛らわしい文字を除外）
const ENCODING = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';

function encodeTime(ms: number, len: number): string {
  let str = '';
  for (let i = len - 1; i >= 0; i--) {
    str = ENCODING[ms % 32] + str;
    ms = Math.floor(ms / 32);
  }
  return str;
}

function encodeRandom(len: number): string {
  // 80bit ランダム: len=16 文字 × 5bit = 80bit
  const bytes = new Uint8Array(len);
  crypto.getRandomValues(bytes);
  let str = '';
  for (let i = 0; i < len; i++) {
    // 各バイト (0–255) を 32 で割り切れる値の範囲内でサンプリング
    // 256 / 32 = 8 なので、単純に % 32 でもバイアスは許容範囲内
    str += ENCODING[bytes[i] % 32];
  }
  return str;
}

/**
 * ULID を生成して返す。
 * 例: "01ARZ3NDEKTSV4RRFFQ69G5FAV"
 */
export function generateUlid(): string {
  const ms = Date.now();
  return encodeTime(ms, 10) + encodeRandom(16);
}
